// Registers the PWA service worker (production only). Network-first, so it never
// serves stale content while online — it just enables installability + offline
// fallback. No-op in dev and where service workers are unsupported.
export function registerSW(): void {
  if (!import.meta.env.PROD) return;
  if (typeof navigator === 'undefined' || !('serviceWorker' in navigator)) return;
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js', { updateViaCache: 'none' }).catch(() => {
      /* registration failure is non-fatal */
    });
  });
}
